export class DeviceConsumableLink {

    public deviceId?: string;
    public consumableId?: string;

    constructor(deviceId: string, consumableId: string) {
        this.deviceId = deviceId;
        this.consumableId = consumableId;
    }
}
